<div class="legend">
  @for (item of items(); track item.label) {
    <div class="legend__item">
      <span class="legend__dot" [style.background]="item.color"></span>
      <span class="legend__label">{{ item.label }}</span>
    </div>
  }
</div>
